webpackJsonp([1],{

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(151);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var firebase = __webpack_require__(156);
// Required for side-effects
__webpack_require__(236);

// var config = {
//   apiKey: 'AIzaSyCsLdVNQtv_RjsvV73JOVlRoLi16l5XrNU', //AIzaSyAe8pRAGGMUBOplBnnVa0lnrLkxFO1Mkk4
//   authDomain: 'mall91-dc1cf.firebaseapp.com',
//   projectId: 'mall91-dc1cf'
// };


var config = {
    apiKey: "AIzaSyA5rXPhkNWNsfnHboP74oWAaMPzHZWSEi8",
    authDomain: "payboard-b01d3.firebaseapp.com",
    databaseURL: "https://payboard-b01d3.firebaseio.com",
    projectId: "payboard-b01d3",
    storageBucket: "payboard-b01d3.appspot.com"
};

firebase.initializeApp(config);
var database = firebase.database();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.database = database;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.firebase = firebase;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51af60a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(150);
function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var normalizeComponent = __webpack_require__(72)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51af60a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'constants',
  BASE_URL: window.location.hostname === 'localhost' ? 'http://localhost:5000/' : "https://aibe.mall91.com/"

});

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container app"},[_c('div',{staticClass:"row app-one"},[_c('div',{staticClass:"col-sm-4 side"},[_c('div',{staticClass:"side-one"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row sideBar"},[_vm._l((_vm.conversations),function(c,index){return _c('div',{key:index,staticClass:"row sideBar-body",class:{'highlight':_vm.selected.number == c.number,'bg-red':c.data.help>2, 'newChat' : c.newChat}},[_c('div',{staticClass:"col-sm-3 col-xs-3 sideBar-avatar"},[_c('div',{staticClass:"avatar-icon"},[(c.data.payment_confirmed)?_c('i',{staticClass:"fa fa-cart-arrow-down payment-confirmed-i"}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-xs-9 sideBar-main",on:{"click":function($event){_vm.getChat(c,index)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-xs-8 sideBar-name"},[_c('span',{staticClass:"name-meta"},[_vm._v("\n                      "+_vm._s(c.data.userName!=null?c.data.userName:"NO NAME")+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-xs-4 pull-right sideBar-time"},[(c.data.lastupdatedat)?_c('span',{staticClass:"time-meta pull-right"},[_vm._v(_vm._s(new Date(c.data.lastupdatedat*1000).toLocaleString()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-xs-8",staticStyle:{"font-size":"12px","position":"absolute","top":"30px"}},[_c('span',{staticClass:"name-meta",staticStyle:{"color":"#959798"}},[_vm._v(_vm._s(c.data.lastMessage))])])])])])}),_vm._v(" "),_c('hr')],2)]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),(_vm.selected.number!=null)?_c('div',{staticClass:"col-sm-8 conversation"},[_c('div',{staticClass:"row heading"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-xs-7 heading-name"},[_c('a',{staticClass:"heading-name-meta"},[_vm._v("\n              "+_vm._s(_vm.selected.number)+"\n            "),_c('button',{staticClass:"btn btn-info btn-sm pull-right",on:{"click":function($event){_vm.closeChat((_vm.selected.data.isOpenChat ? false : true),_vm.selected.number)}}},[_vm._v("\n              "+_vm._s(_vm.selected.data.isOpenChat ? 'OFF' : 'ON')+"\n            ")])]),_vm._v(" "),_c('span',{staticClass:"heading-online"})]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"row message",attrs:{"id":"conversation"}},[_vm._m(5),_vm._v(" "),_vm._l((_vm.chats),function(c,index){return _c('div',{key:index,staticClass:"row message-body"},[_c('div',{staticClass:"col-sm-12 message-main-receiver",class:{'message-main-receiver':!c.incoming, 'message-main-sender':c.incoming}},[_c('div',{class:{'receiver':!c.incoming, 'sender':c.incoming}},[(c.messageType==='SHOPPING_ORDER')?_c('div',{staticClass:"message-text"},[_c('b',[_vm._v("Item Name ")]),_vm._v(" : "),_c('span',[_vm._v(_vm._s(JSON.parse(c.message).itemName || '')+" ")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("Selling Price ")]),_vm._v(" : "),_c('span',[_vm._v(" "+_vm._s(JSON.parse(c.message).sellingPrice || '')+" /- ")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("MRP ")]),_vm._v(" : "),_c('span',[_vm._v(" "+_vm._s(JSON.parse(c.message).mrp)+" /- ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Link ")]),_vm._v(": "),_c('span',[_c('a',{attrs:{"href":JSON.parse(c.message).clickUrl || 'JavaScript:Void(0)'}},[_vm._v(_vm._s(JSON.parse(c.message).clickUrl)+" ")])]),_c('br'),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":JSON.parse(c.message).itemImage,"alt":"","height":"150","width":"100"}})]):_c('div',{staticClass:"message-text"},[_vm._v(_vm._s(c.message))]),_vm._v(" "),(c.timeInMillis)?_c('span',{staticClass:"message-time pull-right"},[_vm._v(" "+_vm._s(new Date(c.timeInMillis*1000).toLocaleTimeString([],{hour12  :true}).replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3"))+" ")]):_vm._e()])])])})],2),_vm._v(" "),_c('div',{staticClass:"row reply"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-xs-9 reply-main"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.msg_to_send),expression:"msg_to_send"}],staticClass:"form-control",attrs:{"disabled":!_vm.selected.data.isOpenChat,"rows":"1","id":"comment"},domProps:{"value":(_vm.msg_to_send)},on:{"keydown":function($event){_vm.checkKey($event)},"input":function($event){if($event.target.composing){ return; }_vm.msg_to_send=$event.target.value}}})]),_vm._v(" "),_vm._m(7),_vm._v(" "),(_vm.selected.data.isOpenChat)?_c('div',{staticClass:"col-sm-1 col-xs-1 reply-send",on:{"click":function($event){_vm.sendMessage()}}},[_c('i',{staticClass:"fa fa-send fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e()])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row heading"},[_c('div',{staticClass:"col-sm-3 col-xs-3 heading-avatar"},[_c('div',{staticClass:"heading-avatar-icon"},[_c('img',{attrs:{"src":"/static/img/bg.webp"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-xs-1 heading-dot pull-right"},[_c('i',{staticClass:"fa fa-ellipsis-v fa-2x pull-right",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-xs-2 heading-compose pull-right"},[_c('i',{staticClass:"fa fa-comments fa-2x pull-right",attrs:{"aria-hidden":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row searchBox"},[_c('div',{staticClass:"col-sm-12 searchBox-inner"},[_c('div',{staticClass:"form-group has-feedback"},[_c('input',{staticClass:"form-control",attrs:{"id":"searchText","type":"text","name":"searchText","placeholder":"Search"}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-search form-control-feedback"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-two"},[_c('div',{staticClass:"row newMessage-heading"},[_c('div',{staticClass:"row newMessage-main"},[_c('div',{staticClass:"col-sm-2 col-xs-2 newMessage-back"},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-10 col-xs-10 newMessage-title"},[_vm._v("New Chat")])])]),_vm._v(" "),_c('div',{staticClass:"row composeBox"},[_c('div',{staticClass:"col-sm-12 composeBox-inner"},[_c('div',{staticClass:"form-group has-feedback"},[_c('input',{staticClass:"form-control",attrs:{"id":"composeText","type":"text","name":"searchText","placeholder":"Search People"}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-search form-control-feedback"})])])]),_vm._v(" "),_c('div',{staticClass:"row compose-sideBar"},[_c('div',{staticClass:"row sideBar-body"},[_c('div',{staticClass:"col-sm-3 col-xs-3 sideBar-avatar"},[_c('div',{staticClass:"avatar-icon"},[_c('img',{attrs:{"src":"/static/img/bg.webp"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-xs-9 sideBar-main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-xs-8 sideBar-name"},[_c('span',{staticClass:"name-meta"},[_vm._v("Ankit Jain")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-xs-4 pull-right sideBar-time"},[_c('span',{staticClass:"time-meta pull-right"},[_vm._v("18:18")])])])])]),_vm._v(" "),_c('div',{staticClass:"row sideBar-body"},[_c('div',{staticClass:"col-sm-3 col-xs-3 sideBar-avatar"},[_c('div',{staticClass:"avatar-icon"},[_c('img',{attrs:{"src":"/static/img/bg.webp"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-xs-9 sideBar-main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-xs-8 sideBar-name"},[_c('span',{staticClass:"name-meta"},[_vm._v("Ankit Jain")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-xs-4 pull-right sideBar-time"},[_c('span',{staticClass:"time-meta pull-right"},[_vm._v("18:18")])])])])]),_vm._v(" "),_c('div',{staticClass:"row sideBar-body"},[_c('div',{staticClass:"col-sm-3 col-xs-3 sideBar-avatar"},[_c('div',{staticClass:"avatar-icon"},[_c('img',{attrs:{"src":"/static/img/bg.webp"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-xs-9 sideBar-main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-xs-8 sideBar-name"},[_c('span',{staticClass:"name-meta"},[_vm._v("Ankit Jain")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-xs-4 pull-right sideBar-time"},[_c('span',{staticClass:"time-meta pull-right"},[_vm._v("18:18")])])])])]),_vm._v(" "),_c('div',{staticClass:"row sideBar-body"},[_c('div',{staticClass:"col-sm-3 col-xs-3 sideBar-avatar"},[_c('div',{staticClass:"avatar-icon"},[_c('img',{attrs:{"src":"/static/img/bg.webp"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-xs-9 sideBar-main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-xs-8 sideBar-name"},[_c('span',{staticClass:"name-meta"},[_vm._v("Ankit Jain")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-xs-4 pull-right sideBar-time"},[_c('span',{staticClass:"time-meta pull-right"},[_vm._v("18:18")])])])])]),_vm._v(" "),_c('div',{staticClass:"row sideBar-body"},[_c('div',{staticClass:"col-sm-3 col-xs-3 sideBar-avatar"},[_c('div',{staticClass:"avatar-icon"},[_c('img',{attrs:{"src":"/static/img/bg.webp"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-xs-9 sideBar-main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-xs-8 sideBar-name"},[_c('span',{staticClass:"name-meta"},[_vm._v("Ankit Jain")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-xs-4 pull-right sideBar-time"},[_c('span',{staticClass:"time-meta pull-right"},[_vm._v("18:18")])])])])]),_vm._v(" "),_c('div',{staticClass:"row sideBar-body"},[_c('div',{staticClass:"col-sm-3 col-xs-3 sideBar-avatar"},[_c('div',{staticClass:"avatar-icon"},[_c('img',{attrs:{"src":"/static/img/bg.webp"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-xs-9 sideBar-main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-xs-8 sideBar-name"},[_c('span',{staticClass:"name-meta"},[_vm._v("Ankit Jain")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-xs-4 pull-right sideBar-time"},[_c('span',{staticClass:"time-meta pull-right"},[_vm._v("18:18")])])])])]),_vm._v(" "),_c('div',{staticClass:"row sideBar-body"},[_c('div',{staticClass:"col-sm-3 col-xs-3 sideBar-avatar"},[_c('div',{staticClass:"avatar-icon"},[_c('img',{attrs:{"src":"/static/img/bg.webp"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-xs-9 sideBar-main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-xs-8 sideBar-name"},[_c('span',{staticClass:"name-meta"},[_vm._v("Ankit Jain")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-xs-4 pull-right sideBar-time"},[_c('span',{staticClass:"time-meta pull-right"},[_vm._v("18:18")])])])])]),_vm._v(" "),_c('div',{staticClass:"row sideBar-body"},[_c('div',{staticClass:"col-sm-3 col-xs-3 sideBar-avatar"},[_c('div',{staticClass:"avatar-icon"},[_c('img',{attrs:{"src":"/static/img/bg.webp"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-xs-9 sideBar-main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-xs-8 sideBar-name"},[_c('span',{staticClass:"name-meta"},[_vm._v("Ankit Jain")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-xs-4 pull-right sideBar-time"},[_c('span',{staticClass:"time-meta pull-right"},[_vm._v("18:18")])])])])]),_vm._v(" "),_c('div',{staticClass:"row sideBar-body"},[_c('div',{staticClass:"col-sm-3 col-xs-3 sideBar-avatar"},[_c('div',{staticClass:"avatar-icon"},[_c('img',{attrs:{"src":"/static/img/bg.webp"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-xs-9 sideBar-main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-xs-8 sideBar-name"},[_c('span',{staticClass:"name-meta"},[_vm._v("Ankit Jain")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-xs-4 pull-right sideBar-time"},[_c('span',{staticClass:"time-meta pull-right"},[_vm._v("18:18")])])])])]),_vm._v(" "),_c('div',{staticClass:"row sideBar-body"},[_c('div',{staticClass:"col-sm-3 col-xs-3 sideBar-avatar"},[_c('div',{staticClass:"avatar-icon"},[_c('img',{attrs:{"src":"/static/img/bg.webp"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-xs-9 sideBar-main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-xs-8 sideBar-name"},[_c('span',{staticClass:"name-meta"},[_vm._v("Ankit Jain")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-xs-4 pull-right sideBar-time"},[_c('span',{staticClass:"time-meta pull-right"},[_vm._v("18:18")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2 col-md-1 col-xs-3 heading-avatar"},[_c('div',{staticClass:"heading-avatar-icon"},[_c('img',{attrs:{"src":"/static/img/bg.webp"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-1 col-xs-1 heading-dot pull-right"},[_c('i',{staticClass:"fa fa-ellipsis-v fa-2x pull-right",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row message-previous"},[_c('div',{staticClass:"col-sm-12 previous"},[_c('a',{attrs:{"onclick":"previous(this)","id":"ankitjain28","name":"20"}},[_vm._v("Show Previous Message!")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-1 col-xs-1 reply-emojis"},[_c('i',{staticClass:"fa fa-smile-o fa-2x"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-1 col-xs-1 reply-recording"},[_c('i',{staticClass:"fa fa-microphone fa-2x",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(153);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }]
}));

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7f08b3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(155);
function injectStyle (ssrContext) {
  __webpack_require__(154)
}
var normalizeComponent = __webpack_require__(72)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7f08b3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 154:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('h2',[_vm._v("Essential Links")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Ecosystem")]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://vuejs.org","target":"_blank","rel":"noopener"}},[_vm._v("Core Docs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://forum.vuejs.org","target":"_blank","rel":"noopener"}},[_vm._v("Forum")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://chat.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("Vue Community Chat")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://twitter.com/vuejs","target":"_blank","rel":"noopener"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuejs-templates.github.io/webpack/","target":"_blank","rel":"noopener"}},[_vm._v("Docs for This Template")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"http://router.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("vue-router")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuex.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("vuex")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vue-loader.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("vue-loader")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://github.com/vuejs/awesome-vue","target":"_blank","rel":"noopener"}},[_vm._v("awesome-vue")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant_js__ = __webpack_require__(149);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    return {
      conversations: [],
      chats: [],
      msg_to_send: "",
      selected: {
        number: null
      },
      listener: null,
      ref: null,
      last_updated_at: null,
      page: 0,
      limit: 0,
      showChat: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    _this.showConversationsList();
  },

  computed: {
    reverseItems: function reverseItems() {
      return this.chats.slice().reverse();
    }
  },
  methods: {
    move: function move(a, from, to) {
      a.splice(to, 0, a.splice(from, 1)[0]);
    },

    updateAutoPilot: function updateAutoPilot() {
      var _this = this;
      var obj = {
        to: this.$data.selected.number,
        flag: !this.$data.selected.data.autopilot
      };
      $.ajax({
        type: "POST",
        url: __WEBPACK_IMPORTED_MODULE_3__constant_js__["a" /* default */].BASE_URL + "chatscreen/set-auto-pilot",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj),
        success: function success(data) {
          _this.$data.selected.data.autopilot = !_this.$data.selected.data.autopilot;
        }
      });
    },
    checkKey: function checkKey(e) {
      if (e.keyCode == 13 && !e.shiftKey) {
        this.sendMessage();
      }
    },
    sendMessage: function sendMessage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this, msgToSend, obj, new_data, setNewData, update_meta_data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.$data.msg_to_send.trim().length > 0)) {
                  _context.next = 20;
                  break;
                }

                _this = _this2;
                msgToSend = _this.$data.msg_to_send;

                console.log('msg send', _this.$data.msg_to_send);

                if (!_this.$data.msg_to_send) {
                  _context.next = 20;
                  break;
                }

                obj = {
                  to: _this.$data.selected.number,
                  message: _this.$data.msg_to_send
                };
                _context.next = 8;
                return _this.database.ref('chat_message_dost/' + obj.to).push();

              case 8:
                new_data = _context.sent;
                _context.next = 11;
                return new_data.set({
                  "channelName": _this.$data.selected.number,
                  "oppunentId": "",
                  "userId": "4808fa487cdf5045cc7f867af38ed9c5",
                  "timeInMillis": _this.firebase.database.ServerValue.TIMESTAMP,
                  "message": obj.message,
                  "messageType": "TEXT",
                  "mediaUrl": ""
                });

              case 11:
                setNewData = _context.sent;

                console.log('setNewData', setNewData);
                _context.next = 15;
                return _this.database.ref("chat_message_dost_meta/" + _this.$data.selected.number).update({
                  "lastMessage": obj.message,
                  "timeInMillis": _this.firebase.database.ServerValue.TIMESTAMP,
                  "isOpenChat": true
                });

              case 15:
                update_meta_data = _context.sent;

                console.log('update_meta_data', update_meta_data);
                _this.showConversationsList();
                _this.$data.msg_to_send = "";

                _this.database.ref("chat_status/" + _this.$data.selected.number).once('value').then(function (snapshot) {
                  var _d = snapshot.val();
                  console.log(_d);
                  if (_d) {
                    var t1 = new Date(_d['user']['timeInMillis']);
                    var t2 = new Date();
                    if ((t2 - t2) / 1000 > 60 || true) {
                      _this.sendNotification(msgToSend);
                    }
                  } else {
                    _this.sendNotification(msgToSend);
                  }
                });

              case 20:

                setTimeout(function () {
                  $("#conversation").scrollTop($("#conversation")[0].scrollHeight);
                }, 200);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    sendNotification: function sendNotification(msgToSend) {
      var _this = this;
      console.log(msgToSend);
      var _msg = { "channelName": "4808fa487cdf5045cc7f867af38ed9c5__" + _this.$data.selected.number, "mediaUrl": "", "message": msgToSend, "messageType": "TEXT", "oppunentId": _this.$data.selected.number, "senderName": "", "timeInMillis": 0, "userId": "4808fa487cdf5045cc7f867af38ed9c5" };
      var obj = { "applicationId": 149, "dataMap": { "message": __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_msg), "subject": "firebase_chat" }, "sendToAll": false, "xAuthIds": [_this.$data.selected.number] };
      $.ajax({
        type: "POST",
        url: "https://be.payboard.in/PayBoard/rest/notification/sendLocalizedNotification",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj),
        success: function success(data) {
          console.log(data);
        }
      });
    },

    getChat: function getChat(obj, index) {
      var _this = this;
      _this.$data.chats = [];
      var temp = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj));
      if (_this.$data.conversations && _this.$data.conversations.length && _this.$data.conversations[index] && _this.$data.conversations[index]['newChat']) {
        _this.$data.conversations[index]['newChat'] = false;
      }
      if (_this.$data.selected != null) {
        _this.database.ref("chat_message_dost/" + temp.number).off();
      }
      _this.$data.listener = _this.database.ref("chat_message_dost/" + temp.number).orderByChild("timeInMillis").limitToLast(100).on("child_added", function (data) {
        var respData = data.val();
        console.log('chats', respData);
        respData['incoming'] = respData.userId && respData.userId === "4808fa487cdf5045cc7f867af38ed9c5" ? true : false;
        if (respData) {
          _this.$data.chats.push(respData);
        }
        setTimeout(function () {
          $("#conversation").scrollTop($("#conversation")[0].scrollHeight);
        }, 200);
      });
      _this.$data.selected = temp;
      _this.$data.page = 0;
    },

    closeChat: function closeChat(booleanValue, conversationId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.database.ref().child("chat_message_dost_meta/" + conversationId).update({
                  "timeInMillis": _this3.firebase.database.ServerValue.TIMESTAMP,
                  "isOpenChat": booleanValue
                });

              case 2:
                console.log('selected', _this3.$data.selected);
                _this3.$data.selected.data.isOpenChat = !_this3.$data.selected.data.isOpenChat;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    showConversationsList: function showConversationsList() {
      var _this = this;
      _this.$data.conversations = [];
      _this.database.ref("chat_message_dost_meta").orderByChild("timeInMillis").limitToLast(100).on("child_added", function (data) {
        var obj = {
          number: data.key,
          data: data.val(),
          incoming: false
        };
        _this.$data.conversations.unshift(obj);
      });
      _this.database.ref("chat_message_dost_meta").orderByChild("timeInMillis").limitToLast(100).on("child_changed", function (data) {
        if (data && data.val()) {
          var temp = data.val();
          var foundUserIndex = _this.$data.conversations.findIndex(function (conversation) {
            return conversation.number === data.key;
          });
          if (foundUserIndex != null) {
            if (_this.$data.conversations[foundUserIndex]) {
              console.log('foundUserIndex data', _this.$data.conversations[foundUserIndex]);
              _this.$data.conversations[foundUserIndex]['newChat'] = true;
              _this.move(_this.$data.conversations, foundUserIndex, 0);
            }
          }
        }
      });
    }
  }
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js PWA'
    };
  }
});

/***/ })

},[102]);


// WEBPACK FOOTER //
// static/js/app.6278468343af0feb7134.js